import RequiredIcon from './RequiredIcon';

export default RequiredIcon;
